import AggregatorsDropdown from 'components/masterData/aggregatorsDropdown'
import { useFormContext } from 'react-hook-form'

const InstaPointsConfiguration = () => {
  const { setValue, getValues } = useFormContext()

  return (
    <div className="mt-6 rounded-lg border border-gray-300 bg-gray-50 p-4">
      <h3 className="mb-4 font-semibold">Insta Points Configuration</h3>
      <p className="mb-4 text-sm text-gray-600">
        Select the aggregators whose orders can be settled partly with Insta
        Points. Clearing the selection disables Insta Points everywhere.
      </p>

      <div className="w-full md:w-1/2">
        <AggregatorsDropdown
          label="Insta Points Aggregators"
          name="mobile.instaPointsAggregators"
          setValue={setValue}
          defaultSelected={getValues('mobile.instaPointsAggregators') || []}
          resetForm={false}
        />
      </div>
    </div>
  )
}

export default InstaPointsConfiguration
